import React from 'react';

import './styles.less';
import IconPlay from './assets/play.svg';
import IconApple from './assets/apple.svg';

const Button = ({
  type = 'button',
  size = 'lg',
  text = '',
  isIcon = false,
  handleClick = () => {},
  variant = 'filled',
  width = 'max-content',
  isStore = false,
}) => {
  const sizeTypes = {
    sm: 'small',
    md: 'medium',
    lg: 'large',
  };

  const variantTypes = {
    default: 'default',
    filled: 'filled',
    link: 'link',
    outline: 'outline',
  };

  return (
    <button
      type={type}
      className={`new-landing-btn new-landing-btn--${sizeTypes[size]} new-landing-btn--${variantTypes[variant]}`}
      onClick={handleClick}
      style={{ width }}
    >
      {text}
      {isStore && (
        <div className="new-landing-btn__store-icons">
          <img width={22} height={27} src={IconApple} alt="app store logo" />
          <img width={25} height={27} src={IconPlay} alt="google play logo" />
        </div>
      )}
      {isIcon && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2534 1.91999C11.1759 1.84239 11.084 1.78082 10.9827 1.73881C10.8815 1.6968 10.773 1.67517 10.6634 1.67517C10.5537 1.67517 10.4452 1.6968 10.344 1.73881C10.2427 1.78082 10.1508 1.84239 10.0734 1.91999L4.46669 7.52666C4.40489 7.58834 4.35586 7.6616 4.3224 7.74224C4.28895 7.82289 4.27173 7.90935 4.27173 7.99666C4.27173 8.08397 4.28895 8.17043 4.3224 8.25108C4.35586 8.33173 4.40489 8.40498 4.46669 8.46666L10.0734 14.0733C10.4 14.4 10.9267 14.4 11.2534 14.0733C11.58 13.7467 11.58 13.22 11.2534 12.8933L6.36002 7.99999L11.26 3.09999C11.58 2.77333 11.58 2.24666 11.2534 1.91999Z"
            fill="#6A26F5"
          />
        </svg>
      )}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/button/index.js